const HEROKUURL = "https://colligere.herokuapp.com";
export { HEROKUURL };
